import de_flag from "../../assets/germany.png";
import uk_flag from "../../assets/united-kingdom.png";
import us_flag from "../../assets/united-states.png";
import sp_flag from "../../assets/spain.png";
import fr_flag from "../../assets/france.png";
import gr_flag from "../../assets/greece.png";
import pl_flag from "../../assets/poland.png";

export const languageData = [
  // {
  //   title: "Deutsch",
  //   code: "de_DE", 
  //   flagImage: de_flag,
  // },
   {
    title: "English (UK)",
    code: "en_GB", 
    flagImage: uk_flag,
  },
  // {
  //   title: "English (US)",
  //   code: "en_US", 
  //   flagImage: us_flag,
  // },
  // {
  //   title: "Español",
  //   code: "es_ES", 
  //   flagImage: sp_flag,
  // },
  // {
  //   title: "Français",
  //   code: "fr_FR",
  //   flagImage: fr_flag,
  // },
  // {
  //   title: "Ελληνικά",
  //   code: "gr_GR",
  //   flagImage: gr_flag,
  // },
  {
    title: "Polski",
    code: "pl_PL", 
    flagImage: pl_flag,
  },
];
